import Container from "@mui/material/Container";
import React from "react";

const SectionContainer = ({ children, ...props }) => {
  return (
    <>
      <Container {...props} 
      maxWidth="xxl" 
      sx={{ mt: 4, mb: 4 }}>
        {children}
      </Container>
    </>
  );
};

export default SectionContainer;
